const LabelRequired = ({ text }) => {
  return (
    <span>
      {text}
      <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
    </span>
  );
};

export default LabelRequired;
